import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core"
import { Form, Formik } from "formik"
import { useContext } from "react"
import { useQueryClient } from "react-query"
import { useHistory } from "react-router"
import * as Yup from "yup"
import CounterHeader from "~/components/Common/CounterHeader"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import serialize from "~/store/serialize"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CreateLearningPathDialog = () => {
  const queryClient = useQueryClient()
  //reused dialog for create course, create lesson, create cliente and create instructor
  const classes = useStyles()
  const history = useHistory()
  const { dialogs, closeDialog, openSnackBar, authContext } =
    useContext(AppContext)
  const thisDialog = dialogs?.["createLearningPathDialog"] || {}
  const { open = false, data } = thisDialog
  let createFuncMutation = thisDialog?.data?.create

  const schema = Yup.object().shape({
    name: Yup.string()
      .required(`Please enter a name`)
      .max(50, "Name must be less than 50 characters"),
  })

  const handleClose = () => {
    closeDialog("createLearningPathDialog", false)
  }

  const onSubmit = (values, actions) => {
    createFuncMutation
      .mutateAsync(values)
      .then((res) => {
        serialize("path", res.data).then((serializedData) => {
          queryClient.setQueryData("paths", (oldData) => {
            return [...oldData, serializedData]
          })
        })
        history.push(`learning-paths/${res.data.id}/content`)
        openSnackBar({
          message: `${"Learning Path Created"}`,
        })
      })
      .catch((err) => {
        // actions.setSubmitting(false)
        openSnackBar({
          message: "There was an error creating a learning path",
        })
      })
      .finally(() => {
        // actions.setSubmitting(false)
        handleClose()
      })
  }

  return (
    <Dialog classes={{ paperWidthSm: classes.dialogMinHeight }} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          New Learning Path
        </Typography>
        <Typography color="primary" variant="subtitle2">
          Create a new learning parth
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{ name: "" }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
          isSubmitting,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent className={classes.dialogContent}>
              <CounterHeader
                title="Learning Path Name"
                value={values.name}
                max={50}
              />
              <TextField
                type="text"
                name="name"
                id="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={
                  <span>{touched.name && errors.name ? errors.name : " "}</span>
                }
                /* eslint-disable-next-line */
                autoFocus
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && e.target.value.length > 0) {
                    onSubmit({ name: e.target.value })
                    e.preventDefault()
                  }
                }}
                error={!!touched.name && !!errors.name}
                variant="filled"
                size="small"
                fullWidth
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Box margin="16px">
                <Button onClick={handleClose} style={{ height: "40px" }}>
                  Cancel
                </Button>
                <LoaderButton
                  type="submit"
                  classoverrides={{
                    wrapper: classes.button,
                    button: {
                      root: classes.buttonRoot,
                    },
                  }}
                  variant="contained"
                  color="secondary"
                  working={isSubmitting}
                  size="small"
                >
                  add
                </LoaderButton>
              </Box>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

CreateLearningPathDialog.propTypes = {}

export default CreateLearningPathDialog
